import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { NewsCategoryComponent } from './news-category.component';

@NgModule({
  imports: [
    CommonModule,
    MediaModule,
    RouterModule,
    UrlModule,
    SlickCarouselModule,
    MatIconModule,
    I18nModule,
    MatMenuModule,
    NewsCategoryComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        NewsCategoryListComponent: {
          component: NewsCategoryComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class NewsCategoryModule {}
